import { Link } from 'react-router-dom';
import { Shield, ChevronLeft } from 'lucide-react';

export const PrivacyPolicy = () => {
  return (
    <div className="subpage-container" data-testid="privacy-policy-page">
      <section className="subpage-hero policy-hero">
        <div className="subpage-hero-inner">
          <div className="policy-top-nav">
            <Link to="/" className="policy-back-link">
              <ChevronLeft size={16} /> Back to Home
            </Link>
          </div>

          <div className="policy-header-content">
            <div className="policy-hero-badge">
              <Shield size={15} /> DATA PROTECTION &amp; PRIVACY
            </div>
            <h1 className="subpage-title">Privacy Policy</h1>
            <p className="policy-effective-date">
              Effective Date: September 9, 2026 · Giraffe Entertainment &amp; Experiences (Giraffe Group)
            </p>
          </div>
        </div>
      </section>

      <div className="subpage-body site-container policy-body">
        <div className="policy-content-card">
          <section className="policy-section">
            <h2>01. Our Commitment to Your Privacy</h2>
            <p>
              At <strong>Giraffe Entertainment &amp; Experiences ("GEE", "we", "our", or "us")</strong>, we deeply respect the privacy of our visitors, patrons, and partners. This Privacy Policy outlines how we collect, handle, protect, and process personal data across our online portal (<strong>gee.rocks</strong>) and on-site ticketing counters in compliance with the <em>Digital Personal Data Protection Act, 2023 (DPDP)</em> and applicable global standards.
            </p>
          </section>

          <section className="policy-section">
            <h2>02. Information We Collect</h2>
            <p>We may collect information in the following categories:</p>
            <ul className="policy-list">
              <li><strong>Contact &amp; Identity Data:</strong> Name, email address, phone number, and organization details submitted through our contact and partnership inquiry forms.</li>
              <li><strong>Booking &amp; Ticketing Data:</strong> Selected experience date, screening time slot, number of guests, and transaction identifiers when booking admissions.</li>
              <li><strong>Technical Telemetry:</strong> Anonymized device information, browser type, IP address, and interaction analytics to ensure website performance and security.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>03. Purpose of Data Processing</h2>
            <p>Your personal data is utilized strictly for lawful purposes:</p>
            <ul className="policy-list">
              <li>Facilitating admissions, ticket generation, and entry verifications at attraction gates.</li>
              <li>Responding to visitor questions, group booking inquiries, and business partnership requests.</li>
              <li>Communicating schedule adjustments, emergency weather advisories, or venue notices.</li>
              <li>Fulfilling statutory tax compliance and regulatory obligations under Indian law.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>04. Payment &amp; Financial Security</h2>
            <p>
              GEE does not store sensitive credit card numbers, debit card PINs, or net banking passwords on our servers. All digital payments are processed through RBI-authorized, PCI-DSS Level 1 certified payment gateways using end-to-end tokenization and cryptographic encryption.
            </p>
          </section>

          <section className="policy-section">
            <h2>05. Cookies &amp; Tracking Technologies</h2>
            <p>
              We utilize essential session cookies and performance telemetry to maintain security, preserve your session preferences, and understand how visitors interact with our pages. You may disable non-essential cookies via your browser settings without affecting core website readability.
            </p>
          </section>

          <section className="policy-section">
            <h2>06. Data Security &amp; Infrastructure</h2>
            <p>
              All data transmitted to and from <strong>gee.rocks</strong> is encrypted using modern <strong>Transport Layer Security (TLS 1.3)</strong>. Our hosting architecture is deployed on secured AWS cloud infrastructure fortified with intrusion prevention, firewalls, and restricted administrative access protocols.
            </p>
          </section>

          <section className="policy-section">
            <h2>07. Data Sharing &amp; Third-Party Disclosures</h2>
            <p>
              We <strong>never sell, rent, or trade your personal data</strong> to third-party marketing brokers. Data is shared solely with trusted service vendors (such as cloud hosting and transactional messaging providers) under strict non-disclosure obligations, or when required by court orders or law enforcement agencies.
            </p>
          </section>

          <section className="policy-section">
            <h2>08. Your Rights &amp; Data Subject Access</h2>
            <p>
              Under the DPDP Act, you have the right to request access to your personal data held with us, seek corrections of inaccurate records, or request deletion of your information, subject to statutory retention mandates.
            </p>
          </section>

          <section className="policy-section">
            <h2>09. Grievance Officer &amp; Inquiries</h2>
            <p>
              If you have questions, concerns, or requests regarding this Privacy Policy or your data rights, please reach our designated Data Privacy Officer:
            </p>
            <div className="policy-contact-box">
              <p><strong>Data Privacy &amp; Grievance Desk</strong></p>
              <p>Giraffe Corporate House, House No 292, Asiad Village, Near Sirifort Auditorium, New Delhi – 110049</p>
              <p>Email: <a href="mailto:hello@giraffegroup.in">hello@giraffegroup.in</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
